import {Button, Table, Tag, Typography} from "antd";
import React, {useEffect} from "react";
import ResultTable from "../Table/ResultTable";
import ResultHeader from "../Table/ResultHeader";
import ResultBody from "../Table/ResultBody";
import ResultRow from "../Table/ResultRow";
import ResultBodyCell from "../Table/ResultBodyCell";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import AppColor from "./AppColor";



export default function MessageSelectedComparison({dataSource}) {

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Folder</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Project</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Plan</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>River</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        dataSource.map(record => {
                            return (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {record?.selection?.base?.project?.information?.folderName}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {record?.selection?.compare?.project?.information?.folderName}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <Tag>{record?.selection?.base?.project?.modelType}</Tag>
                                                    <span style={{
                                                        marginRight: 4,
                                                    }}>{record?.selection?.base?.project?.information?.title?.trim()}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Tag>{record?.selection?.compare?.project?.modelType}</Tag>
                                                    <span style={{
                                                        marginRight: 4,
                                                    }}>{record?.selection?.compare?.project?.information?.title?.trim()}</span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {record?.selection?.base?.plan?.type}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {record?.selection?.compare?.plan?.type}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        <table style={{minWidth: 250}}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {(record?.selection?.compare?.river?.river) ? `${record?.selection?.compare?.river?.river} - ${record?.selection?.compare?.river?.reach}` : '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {(record?.selection?.compare?.river?.river) ? `${record?.selection?.compare?.river?.river} - ${record?.selection?.compare?.river?.reach}` : '-'}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}